import React from "react";
import { HelpCircle } from "lucide-react";
import { faqs } from "../../data/homepageData";

export const FAQSection = () => (
  <section id="faq" className="py-20 bg-slate-900/50">
    <div className="mx-auto max-w-4xl px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold">
          Frequently Asked
          <span className="text-blue-400"> Questions</span>
        </h2>
      </div>

      <div className="space-y-4">
        {faqs.map((faq) => (
          <div key={faq.id} className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h3 className="font-semibold text-lg mb-3 flex items-start gap-3">
              <HelpCircle className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
              {faq.question}
            </h3>
            <p className="text-slate-400 leading-relaxed pl-8">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
